import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'preWrap' })
export class PreWrapPipe implements PipeTransform {
  transform(text: string): string {
    return '<pre>' + text + '</pre>';
  }
}
